
import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import _Tooltip from '@material-ui/core/Tooltip';
import {Html} from './Html';
import { Util } from '../common';
import { getFontSize } from './Base';

const useStylesBootstrap = makeStyles((theme) => ({
  arrow: {
    color: theme.palette.common.black,
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
    padding:"0.4rem 0.7rem",
    borderRadius:"0.15rem"
  },
}));

const BootstrapTooltip = React.forwardRef((props, ref) => {
  const classes = useStylesBootstrap();
  return <_Tooltip arrow ref={ref} classes={classes} {...props} />;
});


export default function Tooltip({description,content,placement,props,key}) {
  if(!description) return content;
  let title = Util.type(description) ==="string" ? <Html key={key} textClassName="mb-0 c-text-s1d5 text-white font-weight-normal" html={description} {...props}></Html>:description;
  return (
      <BootstrapTooltip key={key} title={title} placement={placement} {...props}>
          {content}
      </BootstrapTooltip>
  );
}

Tooltip.defaultProps={
  placement:"top"
}